import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_URL, scroll, getValFromLS } from "../../helpers";

import Alert from "../../components/Alert";
import Notice from "../../components/Notice";
import Hdg from "../../components/Hdg";

import Nav from "../Nav";

import Table1 from "./HotelEditForm/Table1";
import Table2 from "./HotelEditForm/Table2";
import TableApproved from "./HotelEditForm/TableApproved";
import Form from "./HotelEditForm";

const Edit = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { str } = useParams();

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/hotelEditInit`);
			const params = {
				token,
				q: str ? str : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...json.user });

					setDetails({
						...json,
					});

					if (json.status === 1 && json.confirmation) {
						setNotice({
							type: "success",
							text: "This room request is confirmed.",
						});
					}

					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Hotel Management" admin={true} />
						<p>Use this form to manage a room request.</p>

						{notice.type && <Notice data={notice} />}

						<Table1 details={details} />
						<Table2 details={details} />

						<div className="spacer"></div>

						{notice?.type === "success" ? (
							<TableApproved details={details} />
						) : (
							<Form details={details} token={getValFromLS("vtoUserToken")} />
						)}

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Edit;
